import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { Playbook, PlaybookRequest } from "../types/playbooks.types";

import { savePlaybookToCaches } from "./playbooksCacheUtils";

export type UpdatePlaybookMutationPayload = {
    playbookId: number;
    payload: PlaybookRequest;
};

export const useUpdatePlaybookMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<Playbook, Error, UpdatePlaybookMutationPayload>({
        mutationFn: ({ playbookId, payload }) => salesApiService.playbooks.updatePlaybook(playbookId, payload),
        onSuccess: (playbook) => {
            savePlaybookToCaches(queryClient, playbook);
        },
    });
};
